"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _last2 = _interopRequireDefault(require("lodash/last"));

var _isInt = _interopRequireDefault(require("validator/lib/isInt"));

var _FormBlock = _interopRequireDefault(require("../../components/FormBlock"));

var _FieldBlock = _interopRequireDefault(require("../../components/FieldBlock"));

var _TextBlock = _interopRequireDefault(require("../../components/TextBlock"));

var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));

var _ShowConditionsBlock = _interopRequireWildcard(require("./ShowConditionsBlock"));

var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));

var _style = _interopRequireDefault(require("./style.css"));

var _common = _interopRequireDefault(require("../../styles/common.css"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _default = function _default(_ref) {
  var _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? function () {} : _ref$validate,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues,
      _ref$withTemplate = _ref.withTemplate,
      withTemplate = _ref$withTemplate === void 0 ? false : _ref$withTemplate,
      _ref$withBubbleMessag = _ref.withBubbleMessages,
      withBubbleMessages = _ref$withBubbleMessag === void 0 ? false : _ref$withBubbleMessag,
      _ref$withAdjustedPlay = _ref.withAdjustedPlayerSettings,
      withAdjustedPlayerSettings = _ref$withAdjustedPlay === void 0 ? false : _ref$withAdjustedPlay,
      _ref$withAccommodatio = _ref.withAccommodations,
      withAccommodations = _ref$withAccommodatio === void 0 ? false : _ref$withAccommodatio,
      _ref$withBlock = _ref.withBlock,
      withBlock = _ref$withBlock === void 0 ? false : _ref$withBlock,
      _ref$withVisibilityCo = _ref.withVisibilityConditions,
      withVisibilityConditions = _ref$withVisibilityCo === void 0 ? false : _ref$withVisibilityCo,
      _ref$withQuestionNumb = _ref.withQuestionNumbers,
      withQuestionNumbers = _ref$withQuestionNumb === void 0 ? false : _ref$withQuestionNumb,
      _ref$withDefaultValue = _ref.withDefaultValueFromVariable,
      withDefaultValueFromVariable = _ref$withDefaultValue === void 0 ? false : _ref$withDefaultValue,
      withAnswerFeedback = _ref.withAnswerFeedback;

  var getFields = function getFields() {
    var formFields = fields;

    if (withTemplate) {
      formFields = [].concat(_toConsumableArray(formFields), ['template', 'templateSettings', 'isTemplateExpanded']);
    }

    if (withBubbleMessages) {
      formFields = [].concat(_toConsumableArray(formFields), ['bubbleMessages[].id', 'bubbleMessages[].text', 'bubbleMessagesExpanded']);
    }

    if (withAdjustedPlayerSettings) {
      formFields = [].concat(_toConsumableArray(formFields), ['isAdjustedPlayerSettings', 'adjustedPlayerSettings', 'adjustedPlayerSettingsExpanded']);
    }

    if (withAccommodations) {
      formFields = [].concat(_toConsumableArray(formFields), ['isAccommodationsExpanded', 'overrideAccommodations', 'accommodations.masking', 'accommodations.highlighting', 'accommodations.autoplayQuestions', 'accommodations.autoplayChoices']);
    }

    if (withBlock) {
      formFields = [].concat(_toConsumableArray(formFields), ['blockIsSeparatePage', 'blockPlayerTemplate', 'blockPlayerTemplateSettings', 'blockIsPlayerTemplateExpanded', 'isAdjustedPlayerSettings', 'adjustedPlayerSettings']);
    }

    if (withVisibilityConditions) {
      formFields = [].concat(_toConsumableArray(formFields), ['showConditionsExpanded', 'showConditionsRules[].id', 'showConditionsRules[].dataConnector', 'showConditionsRules[].operator', 'showConditionsRules[].value']);
    }

    if (withQuestionNumbers) {
      formFields = [].concat(_toConsumableArray(formFields), ['questionNumbersExpanded', // We use "hide" instead of "show" because we have to have default value as null
      // And we'd like to show numbers by default
      // It could be changed if we update initial values for existing components
      'questionNumbersHide', 'questionNumbersReset', 'questionNumbersResetNumber']);
    }

    if (withDefaultValueFromVariable) {
      formFields = [].concat(_toConsumableArray(formFields), ['defaultValueVariable', 'defaultValueVariableExpanded']);
    }

    if (withAnswerFeedback) {
      formFields = [].concat(_toConsumableArray(formFields), ['isAnswerFeedbackExpanded', 'isAnswerFeedback', 'answerFeedbackCorrectAnswers', 'answerFeedbackPositive', 'answerFeedbackNegative']);
    }

    return formFields;
  };

  var getInitialValues = function getInitialValues() {
    var formInitialValues = initialValues;

    if (withTemplate) {
      formInitialValues = _objectSpread({}, formInitialValues, {
        template: '',
        templateSettings: {},
        isTemplateExpanded: false
      });
    }

    if (withAdjustedPlayerSettings) {
      formInitialValues = _objectSpread({}, formInitialValues, {
        isAdjustedPlayerSettings: false,
        adjustedPlayerSettingsExpanded: false
      });
    }

    return formInitialValues;
  };

  var getValidate = function getValidate(values) {
    var errors = validate(values) || {};

    if (withVisibilityConditions) {
      errors = _objectSpread({}, errors, {}, (0, _ShowConditionsBlock.validate)(values));
    }

    if (withQuestionNumbers) {
      if (!values.questionNumbersHide && values.questionNumbersReset && !(0, _isInt.default)(values.questionNumbersResetNumber, {
        min: 1,
        max: 9999
      })) {
        errors = _objectSpread({}, errors, {
          questionNumbersResetNumber: 'Enter whole number from 1 to 9999'
        });
      }
    }

    return errors;
  };

  return function (WrappedComponent) {
    var Form =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Form, _React$Component);

      function Form() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Form);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          timestamp: +new Date()
        });

        _defineProperty(_assertThisInitialized(_this), "_onTemplateChange", function (event) {
          var _this$props$fields = _this.props.fields,
              template = _this$props$fields.template,
              templateSettings = _this$props$fields.templateSettings;
          var newTemplateName = event.target.value;
          var newTemplate = (0, _find2.default)(_this.props.availableTemplates, {
            name: newTemplateName
          });
          var newTemplateSettings = newTemplate ? newTemplate.defaultSettings : {};
          template.onChange(newTemplateName);
          templateSettings.onChange(newTemplateSettings);
        });

        _defineProperty(_assertThisInitialized(_this), "_renderTemplateBlock", function () {
          var _this$props$fields2 = _this.props.fields,
              template = _this$props$fields2.template,
              templateSettings = _this$props$fields2.templateSettings,
              isTemplateExpanded = _this$props$fields2.isTemplateExpanded;
          var templateSettingsComponent = null;

          if (template.value !== '') {
            var currentTemplate = (0, _find2.default)(_this.props.availableTemplates, {
              name: template.value
            });

            if (currentTemplate) {
              var SettingsComponent = currentTemplate.settingsComponent;

              if (SettingsComponent) {
                templateSettingsComponent = _react.default.createElement(SettingsComponent, {
                  initialValues: _objectSpread({}, currentTemplate.defaultSettings, {}, templateSettings.value),
                  onChange: templateSettings.onChange,
                  settings: _this.props.values,
                  children: _this.props.children,
                  DataConnectorsPicker: _this.props.DataConnectorsPicker
                });
              }
            }
          }

          return _react.default.createElement(_FormBlock.default, {
            title: "Template",
            type: _this.props.formBlockType,
            show: isTemplateExpanded.value,
            handleClick: isTemplateExpanded.onChange
          }, _this.props.availableTemplates.length === 0 ? _react.default.createElement("div", null, "There are no templates available") : _react.default.createElement("div", null, _react.default.createElement("div", {
            className: !templateSettingsComponent ? _common.default.lastRow : ''
          }, _react.default.createElement(_FieldBlock.default, {
            field: template,
            label: "Template",
            comment: "Some templates could override element settings"
          }, _react.default.createElement("select", _extends({}, (0, _domOnlyProps.default)(template), {
            className: "form-control",
            style: {
              width: 'auto'
            },
            onChange: _this._onTemplateChange
          }), _react.default.createElement("option", {
            value: ""
          }, "-- Default --"), _this.props.availableTemplates.map(function (item) {
            return _react.default.createElement("option", {
              value: item.name,
              key: item.name
            }, item.title);
          })))), templateSettingsComponent));
        });

        _defineProperty(_assertThisInitialized(_this), "_changeOverrideAccommodations", function (event) {
          var _this$props$fields3 = _this.props.fields,
              overrideAccommodations = _this$props$fields3.overrideAccommodations,
              _this$props$fields3$a = _this$props$fields3.accommodations,
              masking = _this$props$fields3$a.masking,
              highlighting = _this$props$fields3$a.highlighting,
              autoplayQuestions = _this$props$fields3$a.autoplayQuestions,
              autoplayChoices = _this$props$fields3$a.autoplayChoices;
          var list = [masking, highlighting, autoplayQuestions, autoplayChoices];
          overrideAccommodations.onChange(event);
          list.forEach(function (item) {
            return !item.value && item.onChange(false);
          });
        });

        _defineProperty(_assertThisInitialized(_this), "_renderAccommodationsBlock", function () {
          var _this$props$fields4 = _this.props.fields,
              isAccommodationsExpanded = _this$props$fields4.isAccommodationsExpanded,
              overrideAccommodations = _this$props$fields4.overrideAccommodations,
              _this$props$fields4$a = _this$props$fields4.accommodations,
              masking = _this$props$fields4$a.masking,
              highlighting = _this$props$fields4$a.highlighting,
              autoplayQuestions = _this$props$fields4$a.autoplayQuestions,
              autoplayChoices = _this$props$fields4$a.autoplayChoices;
          var list = [{
            field: masking,
            label: 'Masking'
          }, {
            field: highlighting,
            label: 'Highlighting'
          }, {
            field: autoplayQuestions,
            label: 'Autoplay questions'
          }, {
            field: autoplayChoices,
            label: 'Autoplay choices'
          }];
          return _react.default.createElement(_FormBlock.default, {
            title: "Accommodations",
            type: _this.props.formBlockType,
            show: isAccommodationsExpanded.value,
            handleClick: isAccommodationsExpanded.onChange
          }, _react.default.createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps.default)(overrideAccommodations), {
            checked: !!overrideAccommodations.value,
            onChange: _this._changeOverrideAccommodations
          })), ' ', "Override accommodations")), overrideAccommodations.value && _react.default.createElement("div", {
            className: _common.default.lastRow
          }, _react.default.createElement(_FieldBlock.default, {
            field: masking,
            label: "New accommodations",
            style: {
              marginTop: '1em'
            }
          }, list.map(function (item) {
            return _react.default.createElement("div", {
              key: item.field.name,
              className: "checkbox",
              style: {
                margin: '0'
              }
            }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
              type: "checkbox"
            }, (0, _domOnlyProps.default)(item.field))), ' ', item.label));
          }))));
        });

        _defineProperty(_assertThisInitialized(_this), "_changeIsAdjustedPlayerSettings", function (e) {
          var _this$props$fields5 = _this.props.fields,
              isAdjustedPlayerSettings = _this$props$fields5.isAdjustedPlayerSettings,
              adjustedPlayerSettings = _this$props$fields5.adjustedPlayerSettings;
          var newValue = !isAdjustedPlayerSettings.value;
          isAdjustedPlayerSettings.onChange(newValue);

          if (newValue) {
            adjustedPlayerSettings.onChange({});
          } // Force block on the separate page


          if (_this.props.fields.blockIsSeparatePage) {
            _this.props.fields.blockIsSeparatePage.onChange(true);
          }
        });

        _defineProperty(_assertThisInitialized(_this), "_getNewBubbleMessageId", function () {
          var bubbleMessages = _this.props.fields.bubbleMessages;
          var lastMessage = (0, _last2.default)(bubbleMessages);

          if (lastMessage && lastMessage.id) {
            return lastMessage.id.value + 1;
          }

          return 1;
        });

        _defineProperty(_assertThisInitialized(_this), "_renderBubbleMessagesBlock", function () {
          var _this$props$fields6 = _this.props.fields,
              bubbleMessages = _this$props$fields6.bubbleMessages,
              bubbleMessagesExpanded = _this$props$fields6.bubbleMessagesExpanded;
          return _react.default.createElement(_FormBlock.default, {
            title: "Bubble message",
            type: _this.props.formBlockType,
            show: bubbleMessagesExpanded.value,
            handleClick: bubbleMessagesExpanded.onChange
          }, bubbleMessages.map(function (item, index) {
            return _react.default.createElement("div", {
              key: item.id.value,
              className: _style.default.bubbleMessage
            }, _react.default.createElement("div", {
              className: _style.default.bubbleText
            }, _react.default.createElement(_cccisdWysiwyg.default, {
              content: item.text.value,
              onChange: item.text.onChange
            })), _react.default.createElement("a", {
              onClick: function onClick() {
                return bubbleMessages.removeField(index);
              },
              className: "text-danger"
            }, _react.default.createElement("i", {
              className: "glyphicon glyphicon-remove"
            })));
          }), bubbleMessages.length === 0 && _react.default.createElement("button", {
            type: "button",
            className: "btn btn-default btn-sm",
            onClick: function onClick() {
              return bubbleMessages.addField({
                id: _this._getNewBubbleMessageId(),
                text: ''
              });
            }
          }, "Add message"));
        });

        _defineProperty(_assertThisInitialized(_this), "_renderAdjustedPlayerSettingsBlock", function () {
          var _this$props = _this.props,
              availablePlayerTemplates = _this$props.availablePlayerTemplates,
              currentPlayerTemplateName = _this$props.currentPlayerTemplateName,
              currentPlayerTemplateSettings = _this$props.currentPlayerTemplateSettings;
          var _this$props$fields7 = _this.props.fields,
              isAdjustedPlayerSettings = _this$props$fields7.isAdjustedPlayerSettings,
              adjustedPlayerSettings = _this$props$fields7.adjustedPlayerSettings,
              adjustedPlayerSettingsExpanded = _this$props$fields7.adjustedPlayerSettingsExpanded;
          var templateSettingsComponent;
          var playerTemplate = availablePlayerTemplates.find(function (item) {
            return item.name === currentPlayerTemplateName;
          });

          if (playerTemplate && playerTemplate.settingsComponent) {
            var SettingsComponent = playerTemplate.settingsComponent;
            templateSettingsComponent = _react.default.createElement(SettingsComponent, {
              form: "adjustedPlayerSettings".concat(_this.state.timestamp),
              initialValues: _objectSpread({}, playerTemplate.defaultSettings, {}, currentPlayerTemplateSettings, {}, adjustedPlayerSettings.value),
              baseValues: _objectSpread({}, playerTemplate.defaultSettings, {}, currentPlayerTemplateSettings),
              onChange: adjustedPlayerSettings.onChange,
              showHighlightedFields: true
            });
          }

          return _react.default.createElement(_FormBlock.default, {
            title: "Player settings",
            type: _this.props.formBlockType,
            show: adjustedPlayerSettingsExpanded.value,
            handleClick: adjustedPlayerSettingsExpanded.onChange
          }, _react.default.createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps.default)(isAdjustedPlayerSettings), {
            onChange: _this._changeIsAdjustedPlayerSettings
          })), ' ', "override player settings")), isAdjustedPlayerSettings.value && _react.default.createElement("div", {
            style: {
              marginTop: '0.5em'
            }
          }, _react.default.createElement("div", {
            className: "text-warning",
            style: {
              marginBottom: '.8em'
            }
          }, _react.default.createElement("b", null, "Warning!"), " This element will appear alone on the page"), templateSettingsComponent));
        });

        _defineProperty(_assertThisInitialized(_this), "_changeQuestionNumbersReset", function (event) {
          var _this$props$fields8 = _this.props.fields,
              questionNumbersReset = _this$props$fields8.questionNumbersReset,
              questionNumbersResetNumber = _this$props$fields8.questionNumbersResetNumber;
          questionNumbersReset.onChange(event);
          questionNumbersResetNumber.onChange('1');
        });

        _defineProperty(_assertThisInitialized(_this), "_renderQuestionNumbersBlock", function () {
          var _this$props$fields9 = _this.props.fields,
              questionNumbersExpanded = _this$props$fields9.questionNumbersExpanded,
              questionNumbersHide = _this$props$fields9.questionNumbersHide,
              questionNumbersReset = _this$props$fields9.questionNumbersReset,
              questionNumbersResetNumber = _this$props$fields9.questionNumbersResetNumber;
          return _react.default.createElement(_FormBlock.default, {
            title: "Question numbers",
            type: _this.props.formBlockType,
            show: questionNumbersExpanded.value,
            handleClick: questionNumbersExpanded.onChange
          }, _react.default.createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, _react.default.createElement("label", null, _react.default.createElement("input", {
            type: "checkbox",
            value: !questionNumbersHide.value,
            checked: !questionNumbersHide.value,
            onChange: function onChange() {
              return questionNumbersHide.onChange(!questionNumbersHide.value);
            }
          }), ' ', "show numbers")), !questionNumbersHide.value && _react.default.createElement("div", null, _react.default.createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps.default)(questionNumbersReset), {
            checked: !!questionNumbersReset.value,
            onChange: _this._changeQuestionNumbersReset
          })), ' ', "reset to specific number?")), questionNumbersReset.value && _react.default.createElement("div", {
            className: _common.default.lastRow,
            style: {
              marginTop: '0.5em'
            }
          }, _react.default.createElement(_TextBlock.default, {
            field: questionNumbersResetNumber,
            label: "Start number",
            inputStyle: {
              width: '60px'
            }
          }))));
        });

        _defineProperty(_assertThisInitialized(_this), "_onPlayerTemplateChange", function (event) {
          var _this$props$fields10 = _this.props.fields,
              blockIsSeparatePage = _this$props$fields10.blockIsSeparatePage,
              blockPlayerTemplate = _this$props$fields10.blockPlayerTemplate,
              blockPlayerTemplateSettings = _this$props$fields10.blockPlayerTemplateSettings;
          var newTemplateName = event.target.value;
          blockPlayerTemplate.onChange(newTemplateName);
          blockPlayerTemplateSettings.onChange({});
          blockIsSeparatePage.onChange(true);
        });

        _defineProperty(_assertThisInitialized(_this), "_renderBlockBlock", function () {
          var _this$props2 = _this.props,
              availablePlayerTemplates = _this$props2.availablePlayerTemplates,
              currentPlayerTemplateName = _this$props2.currentPlayerTemplateName,
              currentPlayerTemplateSettings = _this$props2.currentPlayerTemplateSettings;
          var _this$props$fields11 = _this.props.fields,
              blockIsSeparatePage = _this$props$fields11.blockIsSeparatePage,
              blockPlayerTemplate = _this$props$fields11.blockPlayerTemplate,
              blockPlayerTemplateSettings = _this$props$fields11.blockPlayerTemplateSettings,
              blockIsPlayerTemplateExpanded = _this$props$fields11.blockIsPlayerTemplateExpanded,
              isAdjustedPlayerSettings = _this$props$fields11.isAdjustedPlayerSettings,
              adjustedPlayerSettings = _this$props$fields11.adjustedPlayerSettings;
          var templateSettingsComponent;

          if (blockPlayerTemplate.value === '') {
            var playerTemplate = availablePlayerTemplates.find(function (item) {
              return item.name === currentPlayerTemplateName;
            });

            if (playerTemplate && playerTemplate.settingsComponent) {
              var SettingsComponent = playerTemplate.settingsComponent;
              templateSettingsComponent = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
                className: "checkbox",
                style: {
                  margin: 0
                }
              }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
                type: "checkbox"
              }, (0, _domOnlyProps.default)(isAdjustedPlayerSettings), {
                onChange: _this._changeIsAdjustedPlayerSettings
              })), ' ', "override player settings")), isAdjustedPlayerSettings.value && _react.default.createElement("div", {
                style: {
                  marginTop: '0.5em'
                }
              }, _react.default.createElement(SettingsComponent, {
                form: "adjustedPlayerSettings".concat(_this.state.timestamp),
                initialValues: _objectSpread({}, playerTemplate.defaultSettings, {}, currentPlayerTemplateSettings, {}, adjustedPlayerSettings.value),
                baseValues: _objectSpread({}, playerTemplate.defaultSettings, {}, currentPlayerTemplateSettings),
                onChange: adjustedPlayerSettings.onChange,
                showHighlightedFields: true
              })));
            }
          } else {
            var currentTemplate = availablePlayerTemplates.find(function (item) {
              return item.name === blockPlayerTemplate.value;
            });

            if (currentTemplate && currentTemplate.settingsComponent) {
              var _SettingsComponent = currentTemplate.settingsComponent;
              templateSettingsComponent = _react.default.createElement(_SettingsComponent, {
                form: "blockTemplate".concat(_this.state.timestamp),
                initialValues: _objectSpread({}, currentTemplate.defaultSettings, {}, blockPlayerTemplateSettings.value),
                onChange: blockPlayerTemplateSettings.onChange
              });
            }
          }

          var showTemplateSelectbox = availablePlayerTemplates.length > 1 || blockPlayerTemplate.value !== '';
          return _react.default.createElement("div", null, _react.default.createElement("div", {
            className: "checkbox",
            style: {
              marginTop: '0'
            }
          }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps.default)(blockIsSeparatePage), {
            disabled: blockPlayerTemplate.value !== '' || isAdjustedPlayerSettings.value
          })), ' ', "Insert page break before and after block")), _react.default.createElement(_FormBlock.default, {
            title: "Player settings",
            type: "primary",
            show: blockIsPlayerTemplateExpanded.value,
            handleClick: blockIsPlayerTemplateExpanded.onChange
          }, showTemplateSelectbox && _react.default.createElement("div", {
            className: !templateSettingsComponent ? _common.default.lastRow : ''
          }, _react.default.createElement(_FieldBlock.default, {
            field: blockPlayerTemplate,
            label: "Change player template for this block"
          }, _react.default.createElement("select", _extends({}, (0, _domOnlyProps.default)(blockPlayerTemplate), {
            className: "form-control",
            style: {
              width: 'auto'
            },
            onChange: _this._onPlayerTemplateChange
          }), _react.default.createElement("option", {
            value: ""
          }, "-- inherited --"), availablePlayerTemplates.map(function (item) {
            return _react.default.createElement("option", {
              value: item.name,
              key: item.name
            }, item.title);
          })))), templateSettingsComponent));
        });

        _defineProperty(_assertThisInitialized(_this), "_renderDefaultValueVariableBlock", function () {
          var defaultValues = _this.props.defaultValues;
          var _this$props$fields12 = _this.props.fields,
              defaultValueVariable = _this$props$fields12.defaultValueVariable,
              defaultValueVariableExpanded = _this$props$fields12.defaultValueVariableExpanded;
          return _react.default.createElement(_FormBlock.default, {
            title: "Default value from variable",
            type: "primary",
            show: defaultValueVariableExpanded.value,
            handleClick: defaultValueVariableExpanded.onChange
          }, defaultValues.length === 0 ? _react.default.createElement("div", null, "There are no variables to pick") : _react.default.createElement("select", _extends({
            className: "form-control"
          }, (0, _domOnlyProps.default)(defaultValueVariable)), _react.default.createElement("option", {
            value: ""
          }, "-- Pick variable --"), defaultValues.map(function (value) {
            return _react.default.createElement("option", {
              key: value.handle,
              value: value.handle
            }, value.label);
          })));
        });

        _defineProperty(_assertThisInitialized(_this), "_renderAnswerFeedbackBlock", function () {
          var _this$props$fields13 = _this.props.fields,
              isAnswerFeedbackExpanded = _this$props$fields13.isAnswerFeedbackExpanded,
              isAnswerFeedback = _this$props$fields13.isAnswerFeedback,
              answerFeedbackCorrectAnswers = _this$props$fields13.answerFeedbackCorrectAnswers,
              answerFeedbackPositive = _this$props$fields13.answerFeedbackPositive,
              answerFeedbackNegative = _this$props$fields13.answerFeedbackNegative;

          if (!withAnswerFeedback.renderCorrectAnswer) {
            throw new Error('You have to provide renderCorrectAnswer() function');
          }

          return _react.default.createElement(_FormBlock.default, {
            title: "Answer feedback",
            type: _this.props.formBlockType,
            show: isAnswerFeedbackExpanded.value,
            handleClick: function handleClick(show) {
              return isAnswerFeedbackExpanded.onChange(show);
            }
          }, _react.default.createElement("div", {
            className: "checkbox",
            style: _objectSpread({
              marginTop: '0'
            }, !isAnswerFeedback.value && {
              marginBottom: '0'
            })
          }, _react.default.createElement("label", null, _react.default.createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps.default)(isAnswerFeedback), {
            checked: !!isAnswerFeedback.value
          })), ' ', "show answer feedback?")), isAnswerFeedback.value && _react.default.createElement("div", null, withAnswerFeedback.renderCorrectAnswer({
            field: answerFeedbackCorrectAnswers,
            builderProps: _this.props
          }), _react.default.createElement(_FieldBlock.default, {
            field: answerFeedbackPositive,
            label: "Positive feedback"
          }, _react.default.createElement(_cccisdWysiwyg.default, {
            content: answerFeedbackPositive.value,
            onChange: answerFeedbackPositive.onChange
          })), _react.default.createElement("div", {
            className: _common.default.lastRow
          }, _react.default.createElement(_FieldBlock.default, {
            field: answerFeedbackNegative,
            label: "Negative feedback"
          }, _react.default.createElement(_cccisdWysiwyg.default, {
            content: answerFeedbackNegative.value,
            onChange: answerFeedbackNegative.onChange
          })))));
        });

        return _this;
      }

      _createClass(Form, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props3 = this.props,
              valid = _this$props3.valid,
              values = _this$props3.values;

          if ((0, _isEqual2.default)(prevProps.valid, valid) && (0, _isEqual2.default)(prevProps.values, values)) {
            return;
          }

          if (!valid) {
            this.props.showPreviewError();
          } else {
            this.props.updatePreview(values);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement("div", null, _react.default.createElement(WrappedComponent, this.props), withDefaultValueFromVariable && this._renderDefaultValueVariableBlock(), withBubbleMessages && this._renderBubbleMessagesBlock(), withAdjustedPlayerSettings && this._renderAdjustedPlayerSettingsBlock(), withTemplate && this._renderTemplateBlock(), withAccommodations && this._renderAccommodationsBlock(), withBlock && this._renderBlockBlock(), withVisibilityConditions && _react.default.createElement(_ShowConditionsBlock.default, {
            fields: this.props.fields,
            formBlockType: this.props.formBlockType,
            DataConnectorsPicker: this.props.DataConnectorsPicker,
            getDataConnectorMeta: this.props.getDataConnectorMeta
          }), withQuestionNumbers && this._renderQuestionNumbersBlock(), withAnswerFeedback && this._renderAnswerFeedbackBlock());
        }
      }]);

      return Form;
    }(_react.default.Component);

    _defineProperty(Form, "propTypes", {
      fields: _propTypes.default.object.isRequired,
      valid: _propTypes.default.bool,
      values: _propTypes.default.object,
      updatePreview: _propTypes.default.func,
      showPreviewError: _propTypes.default.func,
      availableTemplates: _propTypes.default.array,
      availablePlayerTemplates: _propTypes.default.array,
      currentPlayerTemplateName: _propTypes.default.string,
      currentPlayerTemplateSettings: _propTypes.default.object,
      formBlockType: _propTypes.default.string,
      children: _propTypes.default.array,
      DataConnectorsPicker: _propTypes.default.func,
      getDataConnectorMeta: _propTypes.default.func,
      defaultValues: _propTypes.default.array
    });

    _defineProperty(Form, "defaultProps", {
      updatePreview: function updatePreview() {},
      showPreviewError: function showPreviewError() {},
      formBlockType: 'primary',
      availableTemplates: [],
      availablePlayerTemplates: [],
      getDataConnectorMeta: function getDataConnectorMeta() {},
      defaultValues: []
    });

    return (0, _reduxForm.reduxForm)({
      form: 'builderForm',
      fields: getFields(),
      validate: getValidate,
      initialValues: getInitialValues()
    })(Form);
  };
};

exports.default = _default;